import { getCompanySelected } from '../../utilities/controlStorage'
import ControlTabs from '../../utilities/ControlTabs'

export const companySelected = getCompanySelected()
export const ctsView = new ControlTabs()
